import React, { Fragment, useEffect, useState } from "react";
import {
  Typography,
  Box,
  Button,
  Grid,
  Table,
  TableBody,
  TableContainer,
  TablePagination,
  TextField,
  InputAdornment,
  IconButton,
  FormControl,
  FormHelperText,
} from "@material-ui/core";
import { ValidatorForm, TextValidator } from "react-material-ui-form-validator";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import SearchIcon from "@material-ui/icons/Search";
import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";
import CloseIcon from "@material-ui/icons/Close";
import InputMask from "react-input-mask";
import { Link, useHistory } from "react-router-dom";
import EditIcon from "@material-ui/icons/Edit";
import { makeStyles } from "@material-ui/core/styles";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import StoreMallDirectoryIcon from "@material-ui/icons/StoreMallDirectory";
import styles from "../../../../styles/global-styles";
import { ProductService } from "../../../../services/product.service";
import MovileCollapsibleRow from "../../../stateless/MovileCollapsibleRow";
import { connect } from "react-redux";
import { actions } from "../../../../redux/actions/alert";
import ColorSelect from "../../../shared/selects/ColorSelect";
import AddStockModal from "../../modals/AddStockModal";
import HalfMovileForm from "../forms/HalfMovileForm";
import TableHeadProduct from "../../../shared/table/TableHeadProduct";
import { headCellMovileProduct } from "../../../stateless/headTables/HeadCellMovileProduct";
import ProductTableToolbar from "../../../shared/table/ProductTableToolbar";
import GlobalEdition from "../../modals/GlobalEdition";
import {
  changeRowsPerPage,
  validateEmptyValuesInForm,
} from "../../../../_utils/utils";
import SiteSelect from "../../../shared/selects/SiteSelect";
import DistributionDialog from "../../modals/DistributionDialog";
import { clickCheckbox, selectAllCheckbox } from "../../../../_utils/checkBox";
import { searchMovileByImei } from "../utils.inventory";

const usetSyles = makeStyles(() => ({
  title: styles.title,
  subtitle: styles.subtitle,
  label: styles.label,
  rightButton: styles.buttonRightHeader,
  backgroundIcon: styles.backgroundIcon,
  link: styles.link,
  customSelect: styles.customSelect,
  table: {
    minWidth: 750,
  },
  rowSelected: {
    "&:hover": {
      backgroundColor: "#ccebff !important",
    },
  },
  textField: {
    "& .MuiOutlinedInput-root": {
      width: "230px",
      maxWidth: 250,
    },
  },
}));

const MovileDetail = ({ brand, model, barCode, detailAlert, addAlert }) => {
  const classes = usetSyles();
  const history = useHistory();

  const [movilesProduct, setMovilesProducts] = useState([]);
  const [detailProduct, setDetailProduct] = useState({});
  const [imeiQuery, setImeiQuery] = useState("");
  const [queryParams, setqueryParams] = useState({
    brand,
    model,
    barCode,
    inDistribution: 0,
  });
  const [openNewStockModal, setOpenNewStockModal] = useState(false);
  const [openGlobalModal, setOpenGlobalModal] = useState(false);
  const [openAddedStockModal, setOpenAddedStockModal] = useState(false);
  const [openDistribModal, setOpenDistribModal] = useState(false);
  const [checkProducts, setcheckProducts] = useState();
  /** Pagination */
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  /**Check box options */
  const [selected, setSelected] = useState([]);
  const [errorObject, setErrorObject] = React.useState({
    showError: false,
    message: "",
  });
  const body = { brand, model, inDistribution: 0, productSold: 0, barCode };
  const movileDetail = `${brand} ${model}`;

  useEffect(() => {
    loadMoviles();
  }, []);

  const loadMoviles = async () => {
    try {
      // console.log("body to query", body);
      const { data } = await ProductService.getProductByMovilesWithParams(body);
      /** Exist at least one product (created) in store */
      if (data.length) {
        const {
          movile: { brand, model, barCode, providerId, id },
        } = data[0];
        const productId = data[0].id;
        setDetailProduct({
          ...detailProduct,
          brand,
          model,
          barCode,
          providerId,
          movileId: id,
          productId,
        });
        setMovilesProducts(data);
      } else {
        const errorObj = {
          noAvailable: "No se encontraron productos en el almacén",
        };
        throw errorObj;
      }
    } catch (error) {
      console.log("error loadMoviles", error);
      setTimeout(() => {
        history.push("/dashboard/inventario/moviles");
      }, 2000);
      addAlert({ showAlert: true });
      detailAlert({
        severity: "error",
        message: error.noAvailable ? error.noAvailable : error.msgs,
      });
    }
  };

  const handleActionTrigered = (actionSucceed, actionMessage, option) => {
    addAlert({ showAlert: true });
    if (option === "removed") {
      setSelected([]);
    } else if (option === "created") {
      setOpenAddedStockModal(false);
      setOpenNewStockModal(false);
    } else if (option === "update") {
      setOpenAddedStockModal(false);
      setSelected([]);
    }

    if (actionSucceed) {
      loadMoviles();
      detailAlert({
        severity: "success",
        message: actionMessage,
      });
    } else {
      console.log("message", actionMessage);
      detailAlert({
        severity: "error",
        message: actionMessage,
      });
    }
  };

  const handleQuerySelected = (key, value) => {
    setqueryParams({ ...queryParams, [key]: value === "none" ? "" : value });
  };

  const handleFormSubmitted = (product) => {
    const validatedProduct = validateEmptyValuesInForm(product);
    setDetailProduct({ ...detailProduct, ...validatedProduct });
    setOpenNewStockModal(false);
    setOpenAddedStockModal(true);
  };

  const handleClickCheckbox = (event, movileId) =>
    setSelected(clickCheckbox(movileId, selected));

  const handleChangePage = (event, newPage) => setPage(newPage);

  const handleOnClose = () => setOpenNewStockModal(false);
  const handleOnCloseStock = () => setOpenAddedStockModal(false);
  const handleOnCloseGlobal = () => setOpenGlobalModal(false);
  const handleOnCloseDistrib = () => setOpenDistribModal(false);

  const handleImeiInput = ({ target: { value } }) => setImeiQuery(value);

  const findMovileByImei = async () => {
    try {
      const { imeiCode, brand, model } = await searchMovileByImei(imeiQuery);
      if (model === detailProduct.model) {
        const movileFiltered = movilesProduct.filter(
          (product) => product.movile.imeiCode === imeiCode
        );
        setMovilesProducts(movileFiltered);
      } else {
        setTimeout(() => {
          history.push("/dashboard/inventario/detalle-producto", {
            brand,
            model,
            productTypeId: 1,
          });
        }, 3000);
        addAlert({ showAlert: true });
        detailAlert({
          severity: "info",
          message: `EL IMEI encontrado pertenece a la marca ${brand} y modelo ${model}`,
          time: 3500,
        });
      }
    } catch (error) {
      console.log("error searchImeiMovile", error);
      addAlert({ showAlert: true });
      detailAlert({
        severity: error.imei ? "warning" : "error",
        message: error.imei
          ? `No se encontró equipo móvil asociado al IMEI ${error.imei}`
          : error.msgs,
      });
    }
  };

  const deleteImeiInput = () => {
    setImeiQuery("");
    loadMoviles();
  };

  const searchProductByFilters = async () => {
    console.log("queryParams", queryParams);
    try {
      const { data } = await ProductService.getProductByMovilesWithParams(
        queryParams
      );
      if (data.length) setMovilesProducts(data);
      else {
        addAlert({ showAlert: true });
        detailAlert({
          severity: "warning",
          message: "No se encontraron productos con los filtros seleccionados",
        });
      }
    } catch (error) {
      console.log(error);
      addAlert({ showAlert: true });
      detailAlert({
        severity: "error",
        message: error.msgs || "Error al procesar tu solicitud",
      });
    }
  };

  const handleCheckAllProducts = () => {
    const movilesOnStore = movilesProduct.filter(
      (item) => item.movile.siteId === 1
    );
    if (checkProducts === "0") {
      setErrorObject({
        showError: true,
        message: "Escribir un número diferente a 0 ",
      });
      return;
    } else if (parseInt(checkProducts, 10) > movilesOnStore.length) {
      addAlert({ showAlert: true });
      detailAlert({
        severity: "warning",
        message: `Sólo se tienen disponibles ${movilesOnStore.length} equipos móviles en almacén. Modificar la cantidad a distribuir`,
        time: 4000,
      });
      return;
    } else {
      const idsArray = movilesOnStore.map((elem) => elem.movileId);
      console.log("idsArray", idsArray);
      setSelected(idsArray.slice(0, parseInt(checkProducts, 10)));
    }
  };

  const handleCheckInput = ({ target: { value } }) => {
    if (value !== 0) setErrorObject({ showError: false, message: "" });
    setcheckProducts(value);
  };

  return (
    <Fragment>
      <div style={{ display: "inline-flex" }}>
        <ArrowBackIosIcon color="primary" />
        <Typography variant="body1" component={"div"}>
          <Box mb={3}>
            {" "}
            <Link to="/dashboard/inventario/moviles" className={classes.link}>
              Regresar
            </Link>
          </Box>
        </Typography>
      </div>

      <Grid
        container
        direction="row"
        justify="space-between"
        alignItems="center"
      >
        <Grid item>
          <Typography className={classes.subtitle}>
            Inventario {brand} {model}
          </Typography>
        </Grid>

        <Grid item>
          <ColorSelect color={handleQuerySelected}></ColorSelect>
        </Grid>

        <Grid item>
          <SiteSelect site={handleQuerySelected} showNone />
        </Grid>

        <Grid item>
          <Button
            className={classes.rightButton}
            variant="contained"
            onClick={() => searchProductByFilters()}
            color="primary"
            endIcon={<SearchIcon color="secondary" />}
          >
            Filtrar
          </Button>
        </Grid>

        <ValidatorForm
          noValidate
          onKeyPress={(event) => {
            if (event.which === 13 /* Enter */) {
              event.preventDefault();
            }
          }}
          className={classes.form}
          method="GET"
          onSubmit={handleCheckAllProducts}
          onError={(errors) => {}}
        >
          <Grid item>
            <div style={{ display: "inline-flex" }}>
              <Typography
                variant="body2"
                component={"div"}
                className={classes.label}
              ></Typography>
              <FormControl error={errorObject.showError}>
                <InputMask
                  mask="999"
                  maskChar=""
                  style={{ maxWidth: 150, widht: 150 }}
                  value={checkProducts || ""}
                  onChange={(e) => handleCheckInput(e)}
                >
                  {() => (
                    <TextValidator
                      className={classes.textField}
                      name="checkProducts"
                      placeholder="productos para distribuir"
                      validators={["required"]}
                      errorMessages={[
                        "El campo se encuentra vacio, escribir un número",
                      ]}
                      variant="outlined"
                    ></TextValidator>
                  )}
                </InputMask>
                {errorObject.showError && (
                  <FormHelperText>{errorObject.message}</FormHelperText>
                )}
              </FormControl>

              <Button
                color="primary"
                style={{ marginLeft: 10 }}
                variant="contained"
                className={classes.rightButton}
                type="submit"
                endIcon={<CheckCircleOutlineIcon color="secondary" />}
              >
                Seleccionar
              </Button>
            </div>
          </Grid>
        </ValidatorForm>
      </Grid>

      <Grid
        container
        direction="row"
        justify="flex-start"
        alignItems="center"
        spacing={4}
        style={{ marginTop: 50 }}
      >
        <Grid item>
          <Typography className={classes.header}>Búsqueda por Imei</Typography>
        </Grid>
        <Grid item>
          <InputMask
            mask="999999999999999"
            maskChar=""
            value={imeiQuery || ""}
            onChange={(e) => handleImeiInput(e)}
          >
            {() => (
              <TextField
                className={classes.inputField}
                name="imeiCode"
                placeholder="Imei"
                variant="outlined"
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={() => deleteImeiInput()}
                        onMouseDown={(e) => e.preventDefault()}
                      >
                        {<CloseIcon color="primary" />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            )}
          </InputMask>
        </Grid>
        <Grid item>
          <Button
            className={classes.rightButton}
            variant="contained"
            onClick={() => findMovileByImei()}
            color="primary"
            endIcon={<SearchIcon color="secondary"></SearchIcon>}
          >
            Buscar
          </Button>
        </Grid>
        <Grid item>
          <Button
            className={classes.rightButton}
            onClick={() => setOpenDistribModal(true)}
            disabled={!selected.length}
            variant="contained"
            color="primary"
            endIcon={<StoreMallDirectoryIcon color="secondary" />}
          >
            Distribución
          </Button>
        </Grid>

        <Grid item>
          <Button
            disabled={!selected.length}
            className={classes.rightButton}
            onClick={() => setOpenGlobalModal(true)}
            variant="contained"
            color="primary"
            endIcon={<EditIcon color="secondary" />}
          >
            Edición global
          </Button>
        </Grid>

        <Grid item>
          <Button
            className={classes.rightButton}
            onClick={() => setOpenNewStockModal(true)}
            variant="contained"
            color="primary"
            endIcon={<AddCircleIcon color="secondary"></AddCircleIcon>}
          >
            Nuevo stock
          </Button>
        </Grid>
      </Grid>

      <Grid
        container
        direction="row"
        justify="flex-start"
        alignItems="center"
        spacing={4}
        style={{ marginTop: 50 }}
      ></Grid>

      <ProductTableToolbar
        productsSelected={selected}
        title={""}
        label={" producto(s) seleccionados"}
      />
      <TableContainer style={{ marginTop: 10 }}>
        {movilesProduct.filter(({ movile }) => movile.imeiCode != null).length >
        0 ? (
          <Table
            className={classes.table}
            size={"medium"}
            aria-label="collapsible table"
          >
            <TableHeadProduct
              numSelected={selected.length}
              headCells={headCellMovileProduct}
              onSelectAllClick={(e) =>
                setSelected(selectAllCheckbox(e, movilesProduct, "movile"))
              }
              rowCount={movilesProduct.length}
            />
            <TableBody>
              {movilesProduct
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((product, id) => {
                  return (
                    <MovileCollapsibleRow
                      key={id}
                      selectedExam={selected}
                      row={product}
                      updateMoviles={handleActionTrigered}
                      productRemoved={handleActionTrigered}
                      movileSelected={handleClickCheckbox}
                    />
                  );
                })}
            </TableBody>
          </Table>
        ) : (
          <Typography
            variant="h6"
            component="h4"
            style={{ marginTop: 50 }}
            className={classes.subtitle}
          >
            No se encontraron equipos moviles, agregar nuevo stock
          </Typography>
        )}
      </TableContainer>
      {movilesProduct.length > 0 && (
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={movilesProduct.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onChangePage={handleChangePage}
          onChangeRowsPerPage={(event) => {
            const { rowsPerPage, page } = changeRowsPerPage(event);
            setRowsPerPage(rowsPerPage);
            setPage(page);
          }}
        />
      )}

      {setOpenNewStockModal && (
        <HalfMovileForm
          onClose={handleOnClose}
          open={openNewStockModal}
          formMovileCompleted={handleFormSubmitted}
        />
      )}

      {openGlobalModal && (
        <GlobalEdition
          onClose={handleOnCloseGlobal}
          open={openGlobalModal}
          productsSelected={selected}
          productsUpdated={handleActionTrigered}
          productType={1}
        />
      )}

      {openAddedStockModal && (
        <AddStockModal
          isNewStock={movilesProduct.every(
            ({ movile }) => movile.imeiCode !== null
          )}
          onClose={handleOnCloseStock}
          open={openAddedStockModal}
          productsCreated={handleActionTrigered}
          product={movileDetail}
          detailProduct={detailProduct}
        />
      )}

      {openDistribModal && (
        <DistributionDialog
          title="equipos móviles"
          open={openDistribModal}
          onClose={handleOnCloseDistrib}
          detailProduct={detailProduct}
          productsIdSelected={selected}
          productType="movile"
        />
      )}
    </Fragment>
  );
};

const dispatch = {
  detailAlert: actions.detailAlert,
  addAlert: actions.addAlert,
};

export default connect(undefined, dispatch)(MovileDetail);
